import React, { useState, useRef, useCallback } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { Add, AttachFile, MyLocation, AddShoppingCart, ViewList } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

/**
 * Botão "+" com menu: anexo, produtos, localização (conforme props).
 */
function ComposeAttachMenu({
  openFilePicker,
  showAttachProducts,
  onOpenProductPicker,
  showTemplates,
  onOpenTemplates,
  templatesDisabled,
  templatesDisabledHelp,
  showLocation,
  onSendCurrentLocation,
  locationSendDisabled,
  locationSending,
  locationSendDisabledHelp,
  size = "medium",
}) {
  const { t } = useTranslation("chat");
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef(null);
  const open = Boolean(anchorEl);

  const close = useCallback(() => setAnchorEl(null), []);

  const iconSize = size === "small" ? "small" : "medium";

  return (
    <>
      <Tooltip title={t("input.menuAttachTooltip")}>
        <IconButton
          ref={buttonRef}
          size={size === "small" ? "small" : "medium"}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          aria-label={t("input.menuAttachAria")}
          aria-haspopup="true"
          aria-expanded={open}
        >
          <Add fontSize={iconSize} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={close}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
        slotProps={{
          paper: { sx: { minWidth: 220 } },
        }}
        MenuListProps={{ dense: true }}
        disableScrollLock
      >
        <MenuItem
          onClick={() => {
            openFilePicker?.();
            close();
          }}
          onMouseDown={(e) => e.preventDefault()}
        >
          <ListItemIcon>
            <AttachFile fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={t("input.menuAttachFile")} />
        </MenuItem>
        {showAttachProducts && typeof onOpenProductPicker === "function" ? (
          <MenuItem
            onClick={() => {
              onOpenProductPicker();
              close();
            }}
            onMouseDown={(e) => e.preventDefault()}
          >
            <ListItemIcon>
              <AddShoppingCart fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={t("input.menuAttachProducts")} />
          </MenuItem>
        ) : null}
        {showTemplates && typeof onOpenTemplates === "function" ? (
          <Tooltip title={templatesDisabled ? templatesDisabledHelp || "" : ""}>
            <span>
              <MenuItem
                disabled={!!templatesDisabled}
                onClick={() => {
                  onOpenTemplates();
                  close();
                }}
                onMouseDown={(e) => e.preventDefault()}
              >
                <ListItemIcon>
                  <ViewList fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t("input.menuTemplates", { defaultValue: "Templates" })} />
              </MenuItem>
            </span>
          </Tooltip>
        ) : null}
        {showLocation ? (
          <Tooltip title={locationSendDisabled ? locationSendDisabledHelp || "" : ""}>
            <span>
              <MenuItem
                disabled={locationSendDisabled || locationSending}
                onClick={() => {
                  onSendCurrentLocation?.();
                  close();
                }}
                onMouseDown={(e) => e.preventDefault()}
              >
                <ListItemIcon>
                  <MyLocation fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t("location.sendCurrent")} />
              </MenuItem>
            </span>
          </Tooltip>
        ) : null}
      </Menu>
    </>
  );
}

export default ComposeAttachMenu;
